module.exports = __webpack_public_path__ + "static/img/whale-talk.f4fc06f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whale-talk.png
// module id = lz4I
// module chunks = 0